export default "__VITE_ASSET__gnNAdduA__"